import { Components } from "@mui/material";

export default (): Components["MuiTextField"] => ({
  defaultProps: {
    size: "small",
  },
});
